import { useEffect, useRef, useState } from "react";
import { STORIES } from "../../data/stories";
import StoryHeroCard from "./StoryHeroCard";

/**
 * @param {{ onOpen: (id: string) => void }} props
 */
export default function StoryList({ onOpen }) {
  const stories = STORIES;
  const [shown, setShown] = useState(3);
  const sentinelRef = useRef(null);

  useEffect(() => {
    setShown(3);
  }, []);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel || !("IntersectionObserver" in window)) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShown((current) => Math.min(stories.length, current + 2));
          }
        });
      },
      { rootMargin: "600px 0px" }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [stories.length]);

  const visibleStories = stories.slice(0, shown);
  const allShown = shown >= stories.length;

  return (
    <section className="stories-list" aria-label="Stories">
      <div className="stories-list__intro">
        <div className="stories-list__eyebrow">
          STORIES · {stories.length} FEATURE{stories.length === 1 ? "" : "S"}
        </div>
        <div className="stories-list__header">
          <h1 className="stories-list__title">Stories</h1>
        </div>
      </div>

      <div className="stories-list__stack">
        {visibleStories.map((story, index) => (
          <StoryHeroCard
            key={story.id}
            story={story}
            featured={index === 0}
            onOpen={onOpen}
            index={index}
          />
        ))}
      </div>

      <div ref={sentinelRef} className="stories-list__sentinel" aria-hidden="true" />

      {!allShown && (
        <div className="stories-list__hint">
          <span>SCROLL FOR MORE</span>
        </div>
      )}
    </section>
  );
}
